import { Box } from "@material-ui/core";
import { useContext } from "react";
import BusinessDataComponent from "../../../components/materialui/Shared/BusinessDataComponent";
import AddressDataComponent from "../../../components/materialui/Shared/AddressDataComponent";
import { MedicoTerceiroContext } from "../../../../context/MedicoTerceiroContext";
import FormBase from "../../../../forms/FormBase";
import Steps from "../../../../components/steps/Steps";

export default function BusinessAddressDataStep() {
  const { state, dispatch } = useContext(MedicoTerceiroContext);

  const onInputBusinessChange = (name: string, form: FormBase, value: any) => {
    dispatch({
      type: "UPDATE_FORM",
      payload: { form, value, name },
    });
  };

  const onInputAddressChange = (name: string, form: FormBase, value: any) => {
    dispatch({
      type: "UPDATE_FORM",
      payload: { form, value, name },
    });
  };

  return (
    <div>
      <Steps.StepTitle text="Dados da sua empresa" />

      <Box mt={2}>
        <BusinessDataComponent
          BusinessDataForm={state.BusinessDataForm}
          onInputChange={onInputBusinessChange}
        />
      </Box>

      <Steps.StepTitle text="Endereço Comercial" />

      <Box mt={4}>
        <AddressDataComponent
          AddressDataForm={state.BusinessAddressDataForm}
          onInputChange={onInputAddressChange}
        />
      </Box>
    </div>
  );
}
